import { PageLoader } from '@cosuno/cosuno-ui';
import React, { memo, Suspense } from 'react';
import { Outlet, useNavigation } from 'react-router-dom';

const OutletWithPageLoader: React.FC = () => {
  const { state: navigationState } = useNavigation();

  return (
    <Suspense fallback={<PageLoader />}>
      {navigationState === 'loading' ? <PageLoader /> : <Outlet />}
    </Suspense>
  );
};

export default memo(OutletWithPageLoader);
